import { render, staticRenderFns } from "./ProjectDebug.vue?vue&type=template&id=0cd68703&scoped=true"
import script from "./ProjectDebug.vue?vue&type=script&lang=js"
export * from "./ProjectDebug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd68703",
  null
  
)

export default component.exports